import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_75jdpu9nvf: FaireBrandEntity = {
  token: "b_75jdpu9nvf",
  type: "brand",
  name: "Rehab Lab",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ff8b4ad9a5fe511cab25cab5c219a81c75b59f216c88d0e3b5fdb23b8351591.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3891b24f95d1e682b62b0509273baf90886d5fa902fd76becfa04892e7dd5213.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3ff8b4ad9a5fe511cab25cab5c219a81c75b59f216c88d0e3b5fdb23b8351591.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3891b24f95d1e682b62b0509273baf90886d5fa902fd76becfa04892e7dd5213.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 25,
  isInsider: true,
  description:
    "In the vibrant heart of Los Angeles, REHAB LAB was born from a passion for fashion that’s as unique as the city itself. We create trendy, distinctive pieces for women who want to make a statement and stand out. Each garment blends bold patterns with modern silhouettes, crafted from the finest materials to ensure quality and style. Our commitment extends beyond fashion; we aim to empower and inspire through every collection. Join us on this journey, and let your individuality shine with REHAB LAB.\n\nhttps://shoprehablab.com/",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:44.883Z",
    importedBy: "entity-db-cli",
  },
};
